import { getImagesTheme } from '@wix/ambassador-genie-v1-compose/http';
import { HttpClient } from '@wix/http-client';
import { reportErrorFromGPT } from '../chatController/biUtilts';
import { ChatTopic } from '../chatController/constants';
import { PromptHubAcceptedUrls } from '../chatController/sgChat/constants';
import { RawResponsePromptHub } from '../chatController/sgChat/types';
import { AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS } from '../consts';
import type { PredictKitPromptHub, SendBi } from '../types';
import { PROMPT_ID } from './kitsConstants';

export const predictKitPromptHub = async ({
  client,
  params: { theme, businessTerm, businessDescription, kitDescriptions },
  sendBi,
  featureName,
}: PredictKitPromptHub): Promise<RawResponsePromptHub> => {
  try {
    const { data } = await client.post(PromptHubAcceptedUrls.AI_GATEWAY_URL, {
      appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
      promptId: PROMPT_ID,
      params: {
        theme,
        businessTerm,
        businessDescription,
        kitDescriptions,
      },
      userRequestInfo: {
        additionalTags: 'site_generator,select_kits',
        featureName,
      },
    });
    return data;
  } catch (error: any) {
    const errorResponse = error.response?.data;

    if (sendBi)
      reportErrorFromGPT(
        errorResponse?.message || 'error response',
        errorResponse?.errorCode,
        'predictKitPromptHub',
        'kits' as ChatTopic,
        JSON.stringify({ theme, businessTerm, kitDescriptions }),
        sendBi,
      );

    throw new Error(
      `Failed request to Prompt Hub. appDefId: ${AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS}. promptId: ${PROMPT_ID}`,
    );
  }
};

export const fetchTheme = async (
  client: HttpClient,
  sendBi?: SendBi,
): Promise<string> => {
  try {
    const response = await client.request(getImagesTheme({}));
    const theme = response.data.imagesTheme?.value;

    return theme ?? '';
  } catch (error: any) {
    const errorResponse = error.response?.data;

    if (sendBi)
      reportErrorFromGPT(
        errorResponse?.message || 'error response',
        errorResponse?.errorCode,
        'fetchTheme',
        ChatTopic.Theme,
        '{}',
        sendBi,
      );

    throw new Error(
      'Failed getImagesTheme of the genie-business-insights service',
    );
  }
};
